var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRandomizeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79609 4.84688L1.60547 0.65625C1.23984 0.290625 0.649219 0.290625 0.283594 0.65625C-0.082031 1.02187 -0.082031 1.6125 0.283594 1.97813L4.46484 6.15937L5.79609 4.84688ZM10.2586 0.796875L11.3742 1.9125L0.274219 13.0125C-0.0914062 13.3781 -0.0914062 13.9688 0.274219 14.3344C0.639844 14.7 1.23047 14.7 1.59609 14.3344L12.7055 3.24375L13.8211 4.35937C14.1117 4.65 14.618 4.44375 14.618 4.02187V0.46875C14.618 0.20625 14.4117 0 14.1492 0H10.5961C10.1742 0 9.96797 0.50625 10.2586 0.796875V0.796875ZM9.77109 8.82187L8.44922 10.1437L11.3836 13.0781L10.2586 14.2031C9.96797 14.4937 10.1742 15 10.5961 15H14.1492C14.4117 15 14.618 14.7938 14.618 14.5312V10.9781C14.618 10.5563 14.1117 10.35 13.8211 10.65L12.7055 11.7656L9.77109 8.82187V8.82187Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRandomizeActive);
export default __webpack_public_path__ + "static/media/icon-randomize--active.c49602c762419f3635fc83ec8fb35608.svg";
export { ForwardRef as ReactComponent };